export default class Utils {
  static testShowConsoleLogParam (log) {
    if (log.object && log.variableToLog) {
      console.log(log.object, log.variableToLog)
    } else {
      console.error("Missing parameter. Param should be a array of Object with keys 'object' and 'variableToLog'", log)
    }
  }
  
  static showConsoleLog (logs) {
    if (process.env.NODE_ENV === 'development') {
      if (Array.isArray(logs)) {
        for (const log of logs) {
          this.testShowConsoleLogParam(log)
        }
      } else {
        this.testShowConsoleLogParam(logs)
      }
    }
  }
}


// WEBPACK FOOTER //
// /src/utils.js